// extracted by mini-css-extract-plugin
module.exports = {"filters":"agreements_filters__1wxj-","filter-select":"agreements_filter-select__2ilEh"};